import apiClient from "../api/client";

export default apiClient;
